import { CacheableDataObject } from '../models/CacheableDataObject';
import { League } from '../models/League';
import { GameRoom } from '../models/GameRoom';
import { Character } from 'models/Character.jsx';

class LadderInformationGame extends CacheableDataObject {
	TYPE_SLIPPI_ID = 14;
	beforeConstruct() {
		this.mains = new Map();
		this.leagues = {};
		this.characterLists = {};
		this.characterUpdate = null;
		this.lastUpdatedSeason = null; //Used to transfer certain data after update
	}

	afterUpdate() {
		//Fix characters
		if(this.lastUpdatedSeason) {
			if(this.characterUpdate) {
				this.characterLists[this.lastUpdatedSeason] = this.characterUpdate;
				this.characterUpdate = null;
			}
		}
		this.lastUpdatedSeason = null;
	}

	getMains(limit = 3) {
		const mains = this.getMainsAsMap();
		let totalCount = 0;
		let mainsArray = [];
		for(let [characterId, main] of mains) {
			if(totalCount >= limit) {
				break;
			}
			totalCount++;
			mainsArray.push(main);
		}
		return mainsArray;
	}

	getMainsAsMap() {
		return this.mains;
	}

	getCharacters() {
		const ladder = this.getLadder();
		if(ladder) {
			return this.characterLists[ladder.active_season] || [];
		}
		console.error('I have no ladder do not know to retrieve characters');
		return [];
	}

	getLadder() {
		return GameRoom.retrieveById(this.id);
	}

	get characters() {
		return this.getCharacters();
	}

	get league() {
		const ladder = this.getLadder();
		if(ladder.active_season) {
			return this.leagues[ladder.active_season];
		}
		return null;
	}
}

LadderInformationGame.prototype.dataLocationParsers = {
	highest_league: (object, data) => {
		object.highest_league = data.highest_league ? League.create(data.highest_league) : League.createUnranked();
	},
	ladder: (object, data) => {
		object.ladder = GameRoom.retrieve(data.ladder);
	},
	characters: (informationGame, data) => {
		informationGame.characterUpdate = [];
		_.each(data.characters, (character) => {
			//Use New since these have extra data like percentage used
			informationGame.characterUpdate.push(Character.create(character));
		});
	},
	mains: (informationGame, data) => {
		informationGame.mains = new Map();
		_.each(data.mains, function(character, id) {
			character = Character.retrieve(character);
			informationGame.mains.set(character.id, character);
		});
	},
	league: function(object, data) {
		const league = new League(data.league);
		object.leagues[league.season.id] = league;
		object.lastUpdatedSeason = league.season.id;
	}
};
export { LadderInformationGame };